<h2 class="title">
    <ng-content></ng-content>
</h2>
<hr class="header" />
